export default __webpack_public_path__ + "static/media/input_field.5c1ac041.svg";